import { render, staticRenderFns } from "./p295_item.vue?vue&type=template&id=09978ecc"
import script from "./p295_item.vue?vue&type=script&lang=js"
export * from "./p295_item.vue?vue&type=script&lang=js"
import style0 from "./p295_item.vue?vue&type=style&index=0&id=09978ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {P295AvailabilityPopup: require('/root/containers/hermes_eshop/components/hyper/p295/p295_availabilityPopup.vue').default,P295Badges2: require('/root/containers/hermes_eshop/components/hyper/p295/p295_badges2.vue').default,Availability: require('/root/containers/hermes_eshop/components/core/availability.vue').default,P295PriceExplain: require('/root/containers/hermes_eshop/components/hyper/p295/p295_price_explain.vue').default,Chart: require('/root/containers/hermes_eshop/components/core/chart.vue').default,P295Modal: require('/root/containers/hermes_eshop/components/hyper/p295/p295_modal.vue').default,Rating: require('/root/containers/hermes_eshop/components/core/rating.vue').default,ElementsCoreRow: require('/root/containers/hermes_eshop/components/core/elements/coreRow.vue').default,Reviews: require('/root/containers/hermes_eshop/components/core/reviews.vue').default,ElementBuilder: require('/root/containers/hermes_eshop/components/core/elementBuilder.vue').default})
